import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["rows", "rowTemplate"]

  connect() {
    if (this.rowsTarget.children.length === 0) this.addRow()
    this.rowsTarget.querySelectorAll("tr").forEach((row) => this.syncRow(row))
  }

  addRow() {
    const fragment = this.rowTemplateTarget.content.cloneNode(true)
    this.rowsTarget.appendChild(fragment)
    this.syncRow(this.rowsTarget.lastElementChild)
  }

  removeRow(event) {
    const row = event.target.closest("tr")

    if (this.rowsTarget.children.length === 1) {
      row.querySelectorAll("input, select").forEach((field) => {
        field.value = ""
        field.disabled = false
      })
      row.querySelector("[data-schedule-note]").textContent = ""
      return
    }

    row.remove()
  }

  employeeChanged(event) {
    this.syncEmployee(event.target.closest("tr"))
  }

  typeChanged(event) {
    this.syncType(event.target.closest("tr"))
  }

  syncRow(row) {
    this.syncEmployee(row)
    this.syncType(row)
  }

  syncEmployee(row) {
    const employeeSelect = row.querySelector("[data-employee-select]")
    const selected = employeeSelect.selectedOptions[0]
    const note = row.querySelector("[data-schedule-note]")

    note.textContent = selected?.dataset.schedule || ""
  }

  syncType(row) {
    const typeSelect = row.querySelector("[data-type-select]")
    const selected = typeSelect.selectedOptions[0]
    const requiresSchedule = selected?.dataset.requiresSchedule !== "false"
    const timeFields = row.querySelectorAll("[data-time-field]")

    timeFields.forEach((field) => {
      field.disabled = !requiresSchedule
      if (!requiresSchedule) field.value = ""
    })
  }
}
